<template>

  <!-- News Card -->
  <div
    class="news-card"
    @click="$emit('click')"
    :class="{'cursor-pointer': $listeners.click}">

    <!-- Date -->
    <div
      class="text-body1 q-mb-ss q-mx-sm">
      {{ $date.utcFormat(value.publishedAt, 'DD.MM.YYYY') }}
    </div>

    <!-- Miniature -->
    <file-background
      :ratio="16/12"
      :value="value.miniature"
      class="news-card__miniature"/>

    <div
      class="news-card__body q-ma-sm">

      <div
        v-html="value.title.ru"
        class="news-card__title"/>

      <div
        class="text-small">
        {{ value.annotation.ru | truncate(120) }}
      </div>

    </div>

  </div>

</template>

<script>

  import FileBackground from 'components/file/file-background';

  export default {
    name: 'news-card',
    props: {
      value: {
        type: Object,
        default: () => {},
      },
    },
    components: {
      FileBackground,
    },
  };

</script>

<style lang="scss">

  $cls: news-card;

  .news-card {
    height: 100%;
    color: inherit;

    &:hover {

      .#{$cls}__miniature {
        box-shadow: $card-shadow;
      }
    }

    &__title {
      font-weight: bold;
      font-size: 1.2rem;
      line-height: 1.5rem;
      margin-bottom: $spacer-sm;
    }

    &__miniature {
      width: 100%;
      overflow: hidden;
      border-radius: $card-radius;
      transition: box-shadow .2s linear;
    }
  }

</style>
